import React from "react";
import Hero from "./Hero";
import Research from "./Research";

const Home = () => {
  return (
    <>
      <Hero />
      <Research />
    </>
  );
};

export default Home;
